import { ANIMATION_CURVE, ANIMATION_DELAY, ANIMATION_DURATION } from '../fundamentals';

export interface GetTransitionOptions {
    duration?: number;
    animationDelay?: number;
    animationCurve?: string;
}

export const getTransition = (
    property = 'all',
    {
        duration = ANIMATION_DURATION.default,
        animationCurve = ANIMATION_CURVE.default,
        animationDelay = ANIMATION_DELAY.default,
    }: GetTransitionOptions = {
        duration: ANIMATION_DURATION.default,
        animationCurve: ANIMATION_CURVE.default,
        animationDelay: ANIMATION_DELAY.default,
    }
) => `${property} ${duration}ms ${animationCurve} ${animationDelay}ms`;
